import { render, staticRenderFns } from "./PostsPage.vue?vue&type=template&id=75af9bd6&scoped=true&"
import script from "./PostsPage.vue?vue&type=script&lang=js&"
export * from "./PostsPage.vue?vue&type=script&lang=js&"
import style0 from "./PostsPage.vue?vue&type=style&index=0&id=75af9bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af9bd6",
  null
  
)

export default component.exports